import React from "react";
import {
  Body,
  Button,
  ButtonLayout,
  Modal
} from "@common/AggregationComponent";
import { useDispatch } from "react-redux";
import { AppActions } from "@redux/reducer";
import { useTranslation } from "react-i18next";

const UploadServerErrorModal = (): any => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handlerClose = () => {
    dispatch(AppActions.setUploadServerErrorModal(false));
  };
  return (
    <Modal
      closeLabel={""}
      closeTitle={""}
      errors={[]}
      id="sm-1"
      labelElement="h5"
      onBackdropClick={undefined}
      onRequestClose={undefined}
      title={t("text_system_error")}
      titleId="modal-title"
      trapFocus
      variant="small"
      isOpen
      footer={
        <ButtonLayout reverseOnVertical={false} variant="fluid">
          <Button
            element="button"
            isSmall={false}
            variant="primary"
            width="fullWidth"
            onClick={handlerClose}
          >
            {t("text_ok")}
          </Button>
        </ButtonLayout>
      }
    >
      <Body element="p" variant="standard">
        {t("text_error_image_search_upload_description")}
      </Body>
    </Modal>
  );
};

export default UploadServerErrorModal;
